import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=d035566c&scoped=true&"
import script from "./ImageBox.vue?vue&type=script&lang=js&"
export * from "./ImageBox.vue?vue&type=script&lang=js&"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=d035566c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d035566c",
  null
  
)

export default component.exports